import { CONFIG } from "~/config";
import { store } from "~/state/store";
import { IUserState } from "~/state/user/interfaces";
import { watch, watchPremiumData, watchNotifications } from "~/state/util";

function setFavicon(premium: boolean, notification: boolean) {
	[
		"favicon-manifest",
		"favicon-apple",
		"favicon-ico",
		"favicon-16x16",
		"favicon-32x32",
		"favicon-96x96",
	].forEach((id, index) => {
		const element = document.getElementById(id);

		// manifest
		if (index === 0) {
			element?.setAttribute("href", `/img/favicon/${premium ? "premium" : "common"}/manifest.webmanifest`);
		// apple pripinani na HP
		} else if (index === 1) {
			element?.setAttribute("href", `/img/favicon/${premium ? "premium" : "common"}/apple-touch-icon.png`);
		// favicon.ico
		} else if (index === 2) {
			element?.setAttribute("href", `/img/favicon/${premium ? "premium" : "common"}/${notification ? "notification" : "plain"}/favicon.ico`);
		// ostatni favicony
		} else {
			element?.setAttribute("href", `/img/favicon/${premium ? "premium" : "common"}/${notification ? "notification" : "plain"}/${id}.png`);
		}
	});
}

if (!CONFIG.inFrame) {
	// nahodime na zacatku
	const { user } = store.getState();

	setFavicon(user.user.premium, user.notifications.totalNew > 0);

	// poslouchame na nasledne zmeny
	const wtPremiumData = watch(store.getState, "user", watchPremiumData);
	const wtNotifications = watch(store.getState, "user", watchNotifications);
	const updateFavicon = (newUser: IUserState) => {
		setFavicon(newUser.user.premium, newUser.notifications.totalNew > 0);
	};

	store.subscribe(wtPremiumData(updateFavicon));
	store.subscribe(wtNotifications(updateFavicon));
}
